import { render, staticRenderFns } from "./LabResult.vue?vue&type=template&id=9673bfe8&scoped=true&"
import script from "./LabResult.vue?vue&type=script&lang=js&"
export * from "./LabResult.vue?vue&type=script&lang=js&"
import style0 from "./LabResult.vue?vue&type=style&index=0&id=9673bfe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9673bfe8",
  null
  
)

export default component.exports